import React from 'react';
import PropTypes from 'prop-types';
import PandaPayLoader from '../../utils/lib/PandaPayLoader';

class DetailsFormPandaPay extends React.Component {
    componentDidMount() {
        PandaPayLoader.initPandaPay(publicKey => {
            /*eslint no-undef:*/
            Panda.init(publicKey, 'panda_cc_form');
        });
    }

    render() {
        return (
            <form id="panda_cc_form" hidden>
                <div>
                    <label>First Name</label>
                    <input
                        type="text"
                        data-panda="first_name"
                        value={this.props.formValues.firstName || ''}
                        readOnly
                    />
                </div>
                <div>
                    <label>Last Name</label>
                    <input
                        type="text"
                        data-panda="last_name"
                        value={this.props.formValues.lastName || ''}
                        readOnly
                    />
                </div>

                <div>
                    <label>Credit Card Number</label>
                    <input
                        type="text"
                        data-panda="credit_card"
                        value={this.props.formValues.cardNumber || ''}
                        readOnly
                    />
                </div>

                <div>
                    <label>Expiration</label>
                    <input
                        type="text"
                        data-panda="expiration"
                        value={
                            this.props.formValues.expDate
                                ? this.props.formValues.expDate
                                      .replace('/', '/20')
                                      .replace(/ /g, '')
                                : ''
                        }
                        readOnly
                    />
                </div>

                <div>
                    <label>CVV</label>
                    <input
                        type="text"
                        data-panda="cvv"
                        value={this.props.formValues.cvv || ''}
                        readOnly
                    />
                </div>

                <div>
                    <label>Postal Code</label>
                    <input
                        type="text"
                        value={this.props.formValues.postalCode || ''}
                        readOnly
                    />
                </div>
            </form>
        );
    }
}

DetailsFormPandaPay.propTypes = {
    formValues: PropTypes.object.isRequired
};

export default DetailsFormPandaPay;



// WEBPACK FOOTER //
// ./src/components/Donation/DetailsFormPandaPay.jsx